import { WorkflowDefinitionList } from './list'
import WorkflowDefinitionDetail from './detail'
import WorkflowDefinitionVersionDetail from './version/detail'

export {
  WorkflowDefinitionList,
  WorkflowDefinitionDetail,
  WorkflowDefinitionVersionDetail
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/workflow-configuration/index.js